import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-ba5e2464.mjs';
import './Icon-a7b85e86.mjs';
import './FormElementMixin-29581863.mjs';
import './Input-19e906a1.mjs';
import './MatchMediaMixin-09b141ca.mjs';
import './trapFocus-dc03669f.mjs';
import './DropdownItem-c744c4e9.mjs';
import './Select-be742134.mjs';
import { s as script } from './Timepicker-499884b4.mjs';
export { s as OTimepicker } from './Timepicker-499884b4.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
